import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';
import SessionStorage from 'shared/helpers/sessionStorage';
import { SESSION_STORAGE_KEYS } from 'dashboard/constants/sessionStorage';
import wootAPI from '../api/apiClient';

// Consulta al backend si la sesión (cookie httpOnly) es válida. Reemplaza al antiguo
// `hasAuthCookie()` síncrono que solo miraba cookies del lado del cliente y era
// trivialmente falsificable copiando cookies entre navegadores.
//
// IMPORTANTE: usamos `wootAPI` (axios local de v3) en vez del global `window.axios`.
// El bundle v3app (que sirve `/app/login`, `/app/auth/*`) NO inicializa
// `window.axios` — solo el bundle dashboard lo hace. Si referenciábamos el
// global aquí, en v3 lanzaba ReferenceError, el catch lo absorbía como `false`,
// y el guard mandaba al usuario a la pantalla de login aunque tuviera sesión
// activa en otra pestaña. Con wootAPI funciona en ambos bundles.
//
// Capa 1 anti-cookie-theft — DOS checks complementarios (igual que en
// dashboard/api/auth.js#isAuthenticated):
//   1) sessionStorage debe contener el session_nonce. Sin nonce → false.
//      Frena el ataque del video: cookie clonada a incógnito pasa check del
//      backend pero no tiene nonce local → no redirigimos al dashboard.
//   2) Cookie válida contra backend via /auth/session.
// Si (1) falla → false sin tocar backend. Si (1) pasa pero (2) falla → false.
//
// `withCredentials: true` no es necesario para same-origin (la cookie se envía
// igual), pero lo agregamos por defensa en caso de despliegues con dominios
// distintos para frontend y backend.
export const isAuthenticated = async () => {
  // Check 1: nonce local presente
  const hasNonce = !!SessionStorage.get(SESSION_STORAGE_KEYS.SESSION_NONCE);
  if (!hasNonce) {
    return false;
  }

  // Check 2: backend valida la cookie en DB
  try {
    await wootAPI.get('/auth/session', {
      withCredentials: true,
      skipAuthInterceptor: true,
    });
    return true;
  } catch (error) {
    return false;
  }
};

const getSSOAccountPath = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id = null } = user || {};
  const ssoAccount = accounts.find(
    account => String(account.id) === String(ssoAccountId)
  );
  let accountPath = '';
  if (ssoAccount) {
    accountPath = `accounts/${ssoAccountId}`;
  } else if (accounts.length) {
    // If the account id is not found, redirect to the first account
    const accountId = account_id || accounts[0].id;
    accountPath = `accounts/${accountId}`;
  }
  return accountPath;
};

export const getLoginRedirectURL = ({
  ssoAccountId,
  ssoConversationId,
  user,
}) => {
  const accountPath = getSSOAccountPath({ ssoAccountId, user });
  if (accountPath) {
    if (ssoConversationId) {
      return frontendURL(`${accountPath}/conversations/${ssoConversationId}`);
    }
    return frontendURL(`${accountPath}/dashboard`);
  }
  return DEFAULT_REDIRECT_URL;
};
